export default function buttonScrollNextSection () {
  const buttonScrollNextSection = document.querySelectorAll('.js-btn-scroll-next-section');

  buttonScrollNextSection.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const currentSection = button.closest('.js-hero-banner');
      const nextSection = currentSection.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
}
